import type { Params } from './types';

export function defaultParams(): Params {
  return {
    mode: 'bw',
    thresholdManual: 128,
    colorCount: 6,
    smoothness: 1.0,
    speckle: 2,
    background: 'remove-white',
    backgroundPick: '#ffffff',
    resizeWidth: null,
    resizeHeight: null,
    resizeLockAspect: true,
    autoTrim: true,
    invert: false,
    brightness: 0,
    contrast: 0,
    blur: 0,
    posterize: 0,
    thresholdMethod: 'otsu',
    retraceSvg: false,
    turnPolicy: 'minority',
    opticurve: true,
    opttolerance: 0.2,
    hierarchy: 'stacked',
    curveMode: 'spline',
    layerDifference: 16,
    cornerAngle: 60,
    minPathLength: 4,
    spliceAngle: 45,
    pathPrecision: 3,
    maxIterations: 10,
    svgo: 'safe',
    pathSimplify: 0,
    strokeFill: 'fill',
    strokeWidth: 1,
    mergePaths: true,
    roundCoords: false,
    outputWidth: null,
    outputHeight: null,
    outputUnit: 'px',
    decimalPrecision: 2,
    prettyPrint: false,
    viewBoxOnly: false,
    outputBgFill: 'transparent',
  };
}

export type ParamsAction =
  | { type: 'SET'; key: keyof Params; value: Params[keyof Params] }
  | { type: 'RESET' }
  | { type: 'LOAD'; params: Params }
  | { type: 'SET_MODE'; mode: Params['mode']; loaded?: Params };

export function paramsReducer(state: Params, action: ParamsAction): Params {
  switch (action.type) {
    case 'SET': {
      const otsuFlip = action.key === 'thresholdManual' && state.thresholdMethod === 'otsu';
      if (state[action.key] === action.value && !otsuFlip) return state;
      const next = { ...state, [action.key]: action.value } as Params;
      if (otsuFlip) next.thresholdMethod = 'manual';
      return next;
    }
    case 'RESET':
      return defaultParams();
    case 'LOAD':
      return action.params;
    case 'SET_MODE':
      return action.loaded ?? { ...defaultParams(), mode: action.mode };
  }
}
